import _ from 'lodash'
import download from 'downloadjs'
import FeatureBannerTable from './table'
import { useEffectOnce } from 'react-use'
import FeatureBannerToolBar from './toolbar'
import { useLocation } from 'react-router-dom'
import { groupMembersDownloadPromise, groupMembersPromise } from 'api/Business'
import React, { useState, useEffect, useCallback, useRef } from 'react'

const MealList = props => {
  const ref = useRef()
  const location = useLocation()
  const [users, setUsers] = useState({})
  const [params, setParams] = useState({ page: 1, filters: {} })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    groupMembersPromise(too).then(resp => setUsers(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }
  // end

  const handleExport = useCallback(() => {
    groupMembersDownloadPromise(params)
      .then(resp => download(resp, 'users.csv', 'application/csv'))
  }, [params])

  return (
    <div className={'root'}>
      <FeatureBannerToolBar {...props} params={params} onParamsChange={handleParamsChange} onExport={handleExport} />
      <div className={'content'}>
        <FeatureBannerTable {...props} data={users} page={params.page} onPageChange={handlePageChange} />
      </div>
    </div>
  )
}

export default MealList
